import { isWorkgateConditionRow } from '@/utils/rtJoblistFromDialogInfo'

const YAGIBUDDY_DIALOG_TYPE = 'open-yagibuddy-popup-dialog'
const YAGIBUDDY_DIALOG_NAME = 'yagibuddy'

export function isYagibuddyConditionRow(row: unknown): boolean {
  if (!row || typeof row !== 'object') return false
  const r = row as { dialog_name?: unknown; dialog_type?: unknown }
  return (
    r.dialog_name === YAGIBUDDY_DIALOG_NAME ||
    r.dialog_type === YAGIBUDDY_DIALOG_TYPE
  )
}

export function isSortLastPromoRow(row: unknown): boolean {
  return isWorkgateConditionRow(row) || isYagibuddyConditionRow(row)
}

/**
 * cursor 位置が sort_last（workgate / yagibuddy）ならその cursor。
 * wrap しない。途中の通常 RT を飛ばして末尾の workgate を引き上げない
 * （BUTTON_N 件のあと 3 件目として出して playlist 先頭へ戻るのを防ぐ）。
 * バッチが末尾グループの直前で終わったときだけ YF 前に消化する。
 */
export function findNextSortLastCursor(
  playlist: number[],
  cursor: number,
  rows: unknown[]
): number | null {
  if (!Array.isArray(playlist) || playlist.length === 0) return null
  const list = Array.isArray(rows) ? rows : []
  const i = Math.max(0, cursor | 0)
  if (i >= playlist.length) return null
  if (isSortLastPromoRow(list[playlist[i]])) return i
  return null
}
